// extracted by mini-css-extract-plugin
export var numpadContainer = "_ri-1";
export var phoneButton = "_ri-0";